// extracted by mini-css-extract-plugin
export default {"container":"Message_container__4Tb3J","header":"Message_header__yoUUE","avatar":"Message_avatar__+kw-B","contentWrapper":"Message_contentWrapper__vj34x","time":"Message_time__9qYO8"};